{
  "unavailable": "Обзор недоступен",
  "unavailableHint": "Для сводки по сети нужно право читать узлы, для сводки по платформе — право на площадки. Запросите их у администратора организации.",
  "availability": {
    "noData": "нет данных"
  },
  "network": {
    "title": "Сеть",
    "computedAt": "посчитано в {{at}}",
    "loading": "Считаем сводку по сети…",
    "failed": "Не удалось посчитать сводку по сети",
    "failedHint": "{{reason}} Проверьте связь с сервером — на самой сети это никак не сказывается."
  },
  "platform": {
    "title": "Платформа",
    "subtitle": "версия {{version}} · api работает {{uptime}}",
    "loading": "Опрашиваем платформу…",
    "failed": "Не удалось получить состояние платформы",
    "failedHint": "{{reason}} Если не отвечает сам api, это видно и по индикатору в шапке."
  },
  "tile": {
    "nodesTotal": "Узлов всего",
    "monitorsEnabled_one": "{{enabled}} из {{count}} монитора включено",
    "monitorsEnabled_few": "{{enabled}} из {{count}} мониторов включено",
    "monitorsEnabled_many": "{{enabled}} из {{count}} мониторов включено",
    "monitorsEnabled_other": "{{enabled}} из {{count}} мониторов включено",
    "down": "Не в сети",
    "checksFailing_one": "{{count}} проверка не проходит",
    "checksFailing_few": "{{count}} проверки не проходят",
    "checksFailing_many": "{{count}} проверок не проходят",
    "checksFailing_other": "{{count}} проверок не проходят",
    "allAnswering": "все узлы отвечают",
    "warn": "В тревоге",
    "warnHint": "часть проверок узла не проходит",
    "unknown": "Неизвестно",
    "withoutMonitors_one": "{{count}} без единого монитора",
    "withoutMonitors_few": "{{count}} без единого монитора",
    "withoutMonitors_many": "{{count}} без единого монитора",
    "withoutMonitors_other": "{{count}} без единого монитора",
    "noChecksYet": "проверок ещё не было",
    "availabilityDay": "Доступность за сутки",
    "availabilityWeek": "За неделю",
    "availabilityMonth": "За месяц",
    "agentsOnline": "Агенты на связи",
    "agentsLost_one": "{{count}} потерял связь",
    "agentsLost_few": "{{count}} потеряли связь",
    "agentsLost_many": "{{count}} потеряли связь",
    "agentsLost_other": "{{count}} потеряли связь",
    "allSitesOnline": "все площадки на связи",
    "vncSessions": "Сессии VNC",
    "openNow": "открыто прямо сейчас",
    "videoStreams": "Потоки видео",
    "archiveCount": "архив: {{count}}",
    "backup": "Резервная копия",
    "backupUnknown": "состояние неизвестно",
    "databaseSize": "Объём базы"
  },
  "flapping": {
    "title": "Чаще других падали за сутки",
    "downs": "Падений",
    "transitions": "Смен",
    "empty": "За сутки ничего не падало",
    "emptyHint": "Список наполняется, когда узел уходит в «не в сети». Пустой список здесь — это хорошая новость, а не отсутствие данных."
  },
  "events": {
    "title": "Последние события",
    "emptyHint": "Сюда попадают смены состояния мониторов по всем площадкам организации. Записи появятся, когда узел перестанет отвечать или вернётся в норму."
  },
  "column": {
    "uptime": "Работает",
    "lastSeen": "Виден"
  },
  "dependencies": "Зависимости",
  "databaseTables": "Чем занята база",
  "siteAgents": "Агенты площадок",
  "noAgents": "Ни одного агента",
  "noAgentsHint": "Агент — единственное, что ставится в сеть заказчика. Заведите его в разделе «Агенты» и запустите на сервере площадки.",
  "noChecks": "проверок за период не было",
  "dependency": {
    "answeredIn": "Ответ за {{ms}} мс",
    "ms": "{{ms}} мс",
    "silent": "не отвечает"
  },
  "agent": {
    "online": "{{name}}: на связи",
    "lost": "{{name}}: связь потеряна",
    "never": "{{name}}: ещё ни разу не подключался"
  },
  "database": {
    "empty": "база пуста",
    "telemetryShare": "{{size}} телеметрии — {{share}} %",
    "unreadable": "Объём базы не прочитался: проверьте права роли приложения на pg_catalog"
  },
  "backup": {
    "dirNotSet": "Каталог резервных копий не задан: переменная NETDECK_BACKUP_DIR пуста",
    "dirMissing": "Каталог резервных копий {{directory}} не существует",
    "dirUnreadable": "Каталог резервных копий {{directory}} не читается: {{code}}",
    "noCopies": "В каталоге {{directory}} нет ни одной резервной копии",
    "copiesUnreadable": "Файлы копий в {{directory}} перечислены, но ни один не читается"
  },
  "media": {
    "notChecked": "состояние медиасервера не проверялось"
  },
  "uptime": {
    "seconds_one": "{{count}} с",
    "seconds_few": "{{count}} с",
    "seconds_many": "{{count}} с",
    "seconds_other": "{{count}} с",
    "days": "{{days}} сут {{hours}} ч",
    "hours": "{{hours}} ч {{minutes}} мин",
    "minutes_one": "{{count}} мин",
    "minutes_few": "{{count}} мин",
    "minutes_many": "{{count}} мин",
    "minutes_other": "{{count}} мин"
  }
}
